import {
    ContactField,
    LeadFormPage,
    LeadFormDataType as LeadFormDataTypeView,
    SurveyDataType as SurveyDataTypeView,
    YClientsDataType as YClientsDataTypeView,
    BlsFormQuestion,
    BlsFormPageResultInfo,
    FormDataTypeGradient,
} from '@target-web/leadads-form-view';
import {PAGE_TYPE} from './types';
import {VIEW} from 'utils/types';

export enum FORM_TYPE {
    leadform = 'leadform',
    survey = 'survey',
    yclients = 'yclients',
    business_card = 'business_card',
    bls = 'bls',
}

export type PagePage = {
    type: PAGE_TYPE.page;
    page: {
        id: string;
        blocks: NonNullable<LeadFormPage['blocks']>;
    };
};

type PageResultInfo = {
    type: PAGE_TYPE.result_info;
    page:
        | ({
              type: 'positive';
          } & SurveyResultInfoPositiveResponse)
        | ({
              type: 'negative';
          } & SurveyResultInfoNegativeResponse);
};

type SurveyResultInfoNegativeResponse = {
    title: string;
    description?: string;
    site_url?: string;
    cta_text?: string;
};

type SurveyResultInfoPositiveResponse = {
    promo_code?: {
        promo_code: string;
    };
} & SurveyResultInfoNegativeResponse;

type FormOwnFieldsType = {
    is_filled_previously: boolean;
    is_re_filling: boolean;
};

export type LeadFormDataType = {
    type: FORM_TYPE.leadform;
    form_id: string;
    global_form_id: string;
    pages: LeadFormPage[];
    contact_fields: ContactField[];
    required_answers: boolean;
    is_enable_phone_confirmation?: boolean;
    only_agreement?: boolean;
} & FormOwnFieldsType &
    LeadFormDataTypeView;

export type SurveyDataType = {
    type: FORM_TYPE.survey;
    survey_id: string;
    global_survey_id: string;
    page: {
        completion: number;
    } & (PagePage | PageResultInfo);
    legal_doc_url: string;
} & FormOwnFieldsType &
    Omit<SurveyDataTypeView, 'page'>;

export type BusinessCardDataType = Pick<LeadFormDataType, 'company_title' | 'logo' | 'landing'> & {
    type: FORM_TYPE.business_card;
    layout: VIEW;
} & FormOwnFieldsType;

export type BlsDataType = {
    type: FORM_TYPE.bls;
    id: string;
    questions: BlsFormQuestion[];
    result_info: BlsFormPageResultInfo;
} & FormOwnFieldsType &
    FormDataTypeGradient;

export type YClientsDataType = {
    type: FORM_TYPE.yclients;
    success: boolean;
    data: YClientsDataTypeView;
} & FormOwnFieldsType; // TODO странный тип, проверить

export type FormDataType = LeadFormDataType | SurveyDataType | YClientsDataType | BusinessCardDataType | BlsDataType;
